import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { teamActivityInProcess, successMessage, teamError } from "redux-store/care-team/care-team.selector";
import { deleteSingleteam, getCareTeamWithUserId } from "redux-store/care-team/care-team.slice";
import { AppDispatch } from "redux-store/store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type PropsType = {
  hospitalName: string;
  vetName: string;
  email: string;
  phone: string;
  id: string;
  showButtons: boolean;
  userId?: any;
};

const CareTeamRowAdmin = ({ id, hospitalName, vetName, email, phone, showButtons, userId }: PropsType) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  // const actionCompletionMessage = useSelector(successMessage);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  async function handleDelete(id: string) {
    try {
      setDeletingId(id); // Set the id of the item being deleted
      const res = await dispatch(deleteSingleteam(id));

      alert(res.payload.message);
      navigate("/admin/users");

      if (res.payload.message) {
        dispatch(getCareTeamWithUserId(userId));
      }
    } catch (error) {
      console.error("Failed to delete the team:", error); // Error handling
    } finally {
      setDeletingId(null); // Reset the deleting state
    }
  }

  function handleEdit(id: string) {
    navigate(`/admin/add-care-team/${id}?edit=true`);
  }

  return (
    <>
      <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
        {/* <ToastContainer /> */}
        <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col tw-gap-3">
          {/* 1st main col */}
          <div className="tw-flex tw-flex-col tw-gap-2">
            {/* 1st col */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <span className="tw-font-bold tw-text-base tw-text-darkPurple">Hospital Name</span>
              <span>{hospitalName !== "" ? hospitalName : "None"}</span>
            </div>
            {/* 2nd col */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <span className="tw-font-bold tw-text-base tw-text-darkPurple">Veterinarian Name</span>
              <span className="tw-text-center">{vetName !== "" ? vetName : "None"}</span>
            </div>
            {/* 3rd col */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <span className="tw-font-bold tw-text-base tw-text-darkPurple">Email</span>
              <span className="tw-truncate">{email !== "" ? email : "None"}</span>
            </div>
            {/* 4th col */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <span className="tw-font-bold tw-text-base tw-text-darkPurple">Phone</span>
              <span className="tw-truncate">{phone !== "" ? phone : "None"}</span>
            </div>
            {/* 5th col */}
            {showButtons && (
              <div className="tw-flex tw-justify-end tw-gap-5 tw-mt-5">
                <button
                  onClick={() => handleEdit(id)}
                  className="tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[blue] tw-py-2 tw-px-8 tw-rounded-md"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(id)}
                  className="tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-4 tw-rounded-md"
                >
                  {deletingId === id ? "Deleting..." : "Delete"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default CareTeamRowAdmin;
